export default __webpack_public_path__ + "static/media/Animals-16.0f4a38bc.png";